import { BuyerCheckAgingRow } from 'services/reportsApi';

const HEADERS = [
  'Vendor',
  'Property',
  'Check #',
  'Amount',
  'Mailed On (earliest)',
  'Days Outstanding',
  'Aging Bucket',
  'Current Status',
  'Reissued',
  'Check Count',
] as const;

const fmtDate = (iso: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toISOString().slice(0, 10);
};

const escapeCell = (raw: string | number | null | undefined): string => {
  if (raw === null || raw === undefined) return '';
  const s = String(raw);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

export const toCsv = (rows: BuyerCheckAgingRow[]): string => {
  const lines = [HEADERS.join(',')];
  for (const r of rows) {
    lines.push(
      [
        escapeCell(r.vendor_name ?? ''),
        escapeCell(r.property_name ?? ''),
        escapeCell(r.current_check_number ?? ''),
        escapeCell(r.amount),
        escapeCell(fmtDate(r.earliest_mailed_on)),
        escapeCell(r.days_outstanding),
        escapeCell(r.aging_bucket),
        escapeCell(r.current_check_status ?? ''),
        escapeCell(r.reissued ? 'yes' : 'no'),
        escapeCell(r.check_count),
      ].join(',')
    );
  }
  return lines.join('\r\n');
};

export const csvFilename = (now: Date = new Date()): string => {
  const yyyy = now.getUTCFullYear();
  const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(now.getUTCDate()).padStart(2, '0');
  return `buyer-check-aging-${yyyy}-${mm}-${dd}.csv`;
};

export const triggerCsvDownload = (csv: string, filename: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
